// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"6144ba96","331":"a6bb2789","525":"dc78da60","732":"bde57c00","977":"e6fe23f4"}[chunkId] + ".chunk.js";
};